export const VisualInspectSectionDataP891 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F119VisualInspection',
                label: 'Visually inspect temperature sensor for general condition and signs of any damage.',
                value: formData.F119VisualInspection,
                isRequired: true,
                isMultiline: true,
                xs: 12,
                width: '50%',
                inputWidth: '50%',
                alignItems: 'inherit',
                marginBottom: '15px'
            }]
        }
    ]
});
